module.exports = __webpack_public_path__ + "img/banner-4.055e25c3.png";